import { render, staticRenderFns } from "./FileViewerVideo.vue?vue&type=template&id=28931d4e&scoped=true&"
import script from "./FileViewerVideo.vue?vue&type=script&lang=js&"
export * from "./FileViewerVideo.vue?vue&type=script&lang=js&"
import style0 from "./FileViewerVideo.vue?vue&type=style&index=0&id=28931d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28931d4e",
  null
  
)

export default component.exports